//Include Both Helper File with needed methods

import axios from "axios";

import { loginSuccess, logoutUserSuccess, apiError, AuthError, reset_login_flag } from './reducer';

export const loginUser = (user: any, history: any) => async (dispatch: any) => {
  try {
    const data = {
      action: "auth",
      user: user.email,
      pass: user.password,
    };

    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: '/apiV2/',
      headers: {
        'Content-Type': 'text/plain',
      },
      data,
    };

    const response: any = await axios.request(config);
    // Response may be the full axios response (when no interceptor unwrap)
    // or the already-unwrapped body.
    const payload = response?.data ?? response;

    if (!payload || !payload.token) {
      dispatch(AuthError("Email ou mot de passe invalide. Veuillez réessayer"));
      return;
    }

    localStorage.setItem("authUser", JSON.stringify(payload));
    dispatch(loginSuccess(payload));
    history('/dashboard');
  } catch (error: any) {
    console.error("Login error:", error);
    dispatch(AuthError("Email ou mot de passe invalide. Veuillez réessayer"));
  }
};

export const logoutUser = () => async (dispatch: any) => {
  try {
    localStorage.removeItem("authUser");
    dispatch(logoutUserSuccess(true));
  } catch (error: any) {
    dispatch(apiError(error));
  }
};

export const resetLoginFlag = () => async (dispatch: any) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error: any) {
    dispatch(apiError(error));
  }
};
